import { useMutation, useQueryClient } from '@tanstack/react-query';
import instance from '@src/api/axiosInstance';
import { message } from 'antd';

export function useDeleteSession() {
  const queryClient = useQueryClient();

  return useMutation(
    async ({ sessionId }: { sessionId: string }) => {
      const response = await instance.delete(`/nexa/session/${sessionId}`);
      return response.data;
    },
    {
      onSuccess: () => {
        // Invalidate or refetch session-related queries if needed
        message.info('Session deleted successfully');
        queryClient.invalidateQueries(['nexa-sessions']);
      },
    }
  );
}
